"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentPerformanceService = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var round_1 = __importDefault(require("lodash/round"));
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("../base.service");
var api_constants_1 = require("../../constants/api.constants");
var models_1 = require("../../models");
var AssessmentPerformanceService = /** @class */ (function (_super) {
    __extends(AssessmentPerformanceService, _super);
    function AssessmentPerformanceService(options, assessmentPerformanceClient) {
        var _this = _super.call(this, options) || this;
        _this.assessmentPerformanceClient = assessmentPerformanceClient;
        return _this;
    }
    AssessmentPerformanceService.newInstance = function (options) {
        return new AssessmentPerformanceService(options, insync_assess_sdk_1.AssessmentPerformanceClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }));
    };
    /**
     * Retrieves the students assessment performance by class and templates.
     * @param students               - class students to show
     * @param classIds               - class ids to filter
     * @param assessmentTemplates    - assessment templates array
     */
    AssessmentPerformanceService.prototype.getStudentsAssessmentPerformanceByClassAndTemplate = function (students, classIds, assessmentTemplates) {
        return __awaiter(this, void 0, void 0, function () {
            var assessmentTemplateIds, assessmentPerformance;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assessmentTemplateIds = assessmentTemplates.map(function (template) { return template.id; });
                        return [4 /*yield*/, this.assessmentPerformanceClient.findByContextAndTemplate(classIds, assessmentTemplateIds, this.getDefaultHeaders({ curriculumId: !(0, isEmpty_1.default)(assessmentTemplates) ? assessmentTemplates[0].curriculum : undefined }))];
                    case 1:
                        assessmentPerformance = _a.sent();
                        return [2 /*return*/, students.map(function (student) {
                                return _this.buildStudentAssessmentPerformance(assessmentPerformance, student, assessmentTemplates);
                            })];
                }
            });
        });
    };
    /**
     * Retrieves the assessments performance by Student
     * @param assessments               - assessments
     * @param studentId                 - studentId
     * @param classId                   - classId
     */
    AssessmentPerformanceService.prototype.getAssessmentPerformanceByStudent = function (assessments, studentId, classId) {
        return __awaiter(this, void 0, void 0, function () {
            var assigneesPerformance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentPerformanceClient.findByAssignee(studentId, this.getDefaultHeaders({
                            curriculumId: !(0, isEmpty_1.default)(assessments) ? assessments[0].assessmentTemplate.curriculum : undefined,
                        }))];
                    case 1:
                        assigneesPerformance = _a.sent();
                        assessments = assessments.filter(function (_a) {
                            var assessmentClass = _a.assessmentClass;
                            return assessmentClass.id !== classId;
                        });
                        return [2 /*return*/, this.buildAssessmentPerformancebyAssignee(assessments, assigneesPerformance)];
                }
            });
        });
    };
    /**
     * Builds the student assessment performance
     * @param assessmentPerformance     - assessment performance Dtos array
     * @param student                   - student
     * @param assessmentTemplates       - assessment templates array
     */
    AssessmentPerformanceService.prototype.buildStudentAssessmentPerformance = function (assessmentPerformance, student, assessmentTemplates) {
        var assigneesPerformance = this.buildAssigneePerformance(assessmentPerformance, student, assessmentTemplates);
        var overallPercentage = this.calculateOverallPercentage(assigneesPerformance);
        return new models_1.StudentAssessmentPerformance({
            student: student,
            overallPercentage: overallPercentage,
            assigneesPerformance: assigneesPerformance,
        });
    };
    /**
     * builds Assignee Performance
     * @param assessmentPerformance     - assessment performance Dtos array
     * @param student                   - student
     * @param assessmentTemplates       - assessment templates array
     */
    AssessmentPerformanceService.prototype.buildAssigneePerformance = function (assessmentPerformance, student, assessmentTemplates) {
        var _this = this;
        return assessmentTemplates.map(function (assessmentTemplate) {
            var assessmentPerformanceDto = assessmentPerformance.find(function (_a) {
                var assessmentTemplateId = _a.assessmentTemplateId;
                return assessmentTemplateId === assessmentTemplate.id;
            });
            if (assessmentPerformanceDto && assessmentPerformanceDto.assigneesPerformance) {
                var assigneePerformanceDto = assessmentPerformanceDto.assigneesPerformance.find(function (_a) {
                    var assigneeId = _a.assigneeId;
                    return assigneeId === student.id;
                });
                if (assigneePerformanceDto) {
                    var maxScore = assessmentPerformanceDto.assessmentTemplateMaxScore;
                    var assessmentTemplateId = assigneePerformanceDto.assessmentTemplateId, averageScore = assigneePerformanceDto.averageScore;
                    var overallPercentage = _this.calculatePercentage(averageScore, maxScore);
                    return new models_1.AssigneePerformance({
                        assessmentTemplateId: assessmentTemplateId,
                        maxScore: maxScore,
                        averageScore: averageScore,
                        overallPercentage: overallPercentage,
                    });
                }
            }
            return new models_1.AssigneePerformance();
        });
    };
    /**
     * Retrieves the overall student assessment performance
     * @param {AssessmentTemplate[]}           assessmentTemplates             - assessment templates
     * @param {StudentAssessmentPerformance[]} studentAssessmentPerformance    - students assessment performance
     */
    AssessmentPerformanceService.prototype.getOverallStudentAssessmentPerformance = function (assessmentTemplates, studentAssessmentPerformance) {
        return __awaiter(this, void 0, void 0, function () {
            var assigneesPerformance, overallPercentage;
            return __generator(this, function (_a) {
                assigneesPerformance = this.buildOverallAssigneesPerformance(assessmentTemplates, studentAssessmentPerformance);
                overallPercentage = this.calculateOverallPercentage(assigneesPerformance);
                return [2 /*return*/, new models_1.OverallStudentAssessmentPerformance({
                        overallPercentage: overallPercentage,
                        assigneesPerformance: assigneesPerformance,
                    })];
            });
        });
    };
    /**
     * Builds the information for the overall assignee performance.
     * @param {AssessmentTemplate[]}           assessmentTemplates              - assessment templates
     * @param {StudentAssessmentPerformance[]} studentsAssessmentPerformance    - students assessment performance
     */
    AssessmentPerformanceService.prototype.buildOverallAssigneesPerformance = function (assessmentTemplates, studentsAssessmentPerformance) {
        var _this = this;
        return assessmentTemplates.map(function (assessmentTemplate) {
            var averageScore = 0;
            var maxScore = 0;
            var totalStudents = 0;
            studentsAssessmentPerformance.forEach(function (studentPerformance) {
                var performance = studentPerformance.assigneesPerformance.find(function (_a) {
                    var assessmentTemplateId = _a.assessmentTemplateId;
                    return assessmentTemplateId === assessmentTemplate.id;
                });
                if (performance && !(0, isEmpty_1.default)(performance) && performance.averageScore) {
                    maxScore = performance.maxScore;
                    averageScore += performance.averageScore;
                    ++totalStudents;
                }
            });
            averageScore = averageScore !== 0 ? (0, round_1.default)(averageScore / totalStudents) : 0;
            var overallPercentage = _this.calculatePercentage(averageScore, maxScore);
            return new models_1.AssigneePerformance({
                assessmentTemplateId: assessmentTemplate.id,
                maxScore: maxScore,
                averageScore: averageScore,
                overallPercentage: overallPercentage,
            });
        });
    };
    /**
     * Returns the percentage based on the provided data, if maxScore is 0 it returns 0
     * @param averageScore
     * @param maxScore
     */
    AssessmentPerformanceService.prototype.calculatePercentage = function (averageScore, maxScore) {
        if (averageScore === void 0) { averageScore = 0; }
        if (maxScore === void 0) { maxScore = 0; }
        return maxScore ? (averageScore / maxScore) * 100 : 0;
    };
    /**
     * Returns the assessments overall percentage per student
     * @param assigneesPerformance     - assignee performances array
     */
    AssessmentPerformanceService.prototype.calculateOverallPercentage = function (assigneesPerformance) {
        var totalPercentages = assigneesPerformance.reduce(function (sum, assignee) {
            return typeof assignee.overallPercentage === 'number' ? sum + assignee.overallPercentage : sum;
        }, 0);
        var totalAssignees = assigneesPerformance.filter(function (assignee) { return !(0, isEmpty_1.default)(assignee); }).length;
        return totalPercentages ? totalPercentages / totalAssignees : 0;
    };
    AssessmentPerformanceService.prototype.buildAssessmentPerformancebyAssignee = function (assessments, assessmentPerformanceDtos) {
        var _this = this;
        var assessmentsPerformance = [];
        assessments.forEach(function (assessment) {
            var performance = assessmentPerformanceDtos.find(function (_a) {
                var assessmentId = _a.assessmentId;
                return assessmentId === assessment.id;
            });
            if (performance) {
                var maxScore = performance.maxScore, score = performance.score, totalAssignees = performance.totalAssignees;
                var percentage = _this.calculatePercentage(score, maxScore);
                assessmentsPerformance.push(new models_1.AssessmentPerformance({
                    assessment: assessment,
                    maxScore: maxScore,
                    score: score,
                    percentage: percentage,
                    totalAssignees: totalAssignees,
                }));
            }
        });
        return assessmentsPerformance;
    };
    return AssessmentPerformanceService;
}(base_service_1.BaseService));
exports.AssessmentPerformanceService = AssessmentPerformanceService;
